import { useTheme } from '@mui/material';
import { ReactComponent as DownloadIcon } from '../../assets/download.svg';
import Button, { Props as ButtonProps } from '../Button';

type Props = Omit<
  ButtonProps,
  'variant' | 'color' | 'startIcon' | 'children'
> & {
  isExporting?: boolean;
};

const CsvExportButton = ({ isExporting, ...props }: Props) => {
  const theme = useTheme();

  return (
    <Button
      variant="outlined"
      color={theme.tokens.components.toolbar.buttonColor}
      startIcon={<DownloadIcon width={12} />}
      {...props}
    >
      {isExporting ? 'Exporting...' : 'CSV'}
    </Button>
  );
};

export default CsvExportButton;
